import { useCallback, useEffect, useRef, useState } from 'react';
import { draftManager, DraftIdentity } from '../utils/DraftManager';

export interface UseDraftOptions {
	value: () => any;
	identity: DraftIdentity | null;
}

export interface UseDraftResult {
	restored: string | null;
}

const useDraft = (options: UseDraftOptions): UseDraftResult => {
	const value = options.value;
	const identity = options.identity;

	const [restored] = useState<string | null>(() => (identity ? draftManager.read(identity) : null));

	const valueRef = useRef(value);
	valueRef.current = value;
	const identityRef = useRef(identity);
	identityRef.current = identity;

	const save = useCallback((): void => {
		const currentIdentity = identityRef.current;
		if (!currentIdentity) {
			return;
		}
		const draft = valueRef.current();
		if (!draft) {
			draftManager.clear(currentIdentity);
			return;
		}
		draftManager.write(currentIdentity, draft);
	}, []);

	useEffect(() => {
		return () => {
			save();
		};
	}, [save]);

	return {
		restored: restored,
	};
};

export default useDraft;
